<form [formGroup]="welcomeForm" fxFlex="0 0 100%" fxLayout="row wrap">
    <mat-form-field fxFlex="1 0 100%">
        <input matInput placeholder="Subject/Title" i18n-placeholder formControlName="subject" />
        <mat-error i18n="@@aSubjectIsRequired">A subject is required!</mat-error>
    </mat-form-field>
    <mat-expansion-panel
        *ngIf="!params.users_attach || params.users_attach.length > 1"
        [expanded]="false"
        class="no-shadow users-panel"
        fxFlex="0 0 100%"
    >
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon class="mr-1 app-icon">group</mat-icon>
                <ng-container i18n="@@editRecipients">Edit recipients</ng-container>
            </mat-panel-title>
            <mat-panel-description *ngIf="welcomeForm.value.users_attach?.length || userSelect.total">
                ({{ userSelect.selected }}/{{ userSelect.total }})
                <ng-container i18n="@@userSelected">user selected</ng-container>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <app-admin-users-select
            #userSelect
            [customer_id]="params.customer_id"
            [referenceIdKey]="params.idKey"
            [referenceFilter]="params.filterKey || params.idKey"
            [accessForm]="welcomeForm"
            defaultSorting="fname"
        ></app-admin-users-select>
    </mat-expansion-panel>
    <div class="send-email-options" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
        <span class="send-email-label">
            <mat-icon>schedule_send</mat-icon>
            <span i18n="@@scheduleSendingEmail">Schedule sending email</span></span
        >
        <mat-radio-group
            class="send-email-radio"
            fxLayout="row wrap"
            fxLayoutGap="24px"
            fxLayoutGap.lt-md="12px"
            [formControl]="send_email"
            (change)="onSendEmailModeChange($event.value)"
        >
            <mat-radio-button value="1" i18n="@@sendEmailNow">Send email now</mat-radio-button>
            <mat-radio-button value="2" i18n="@@scheduleSendingEmail">Schedule time</mat-radio-button>
        </mat-radio-group>
        <mat-form-field *ngIf="send_email.value === '2'" class="schedule-date-field" fxFlex="0 0 240px">
            <input
                matInput
                formControlName="scheduled_send_date"
                [ngxMatDatetimePicker]="scheduledSendDatePicker"
                (focus)="scheduledSendDatePicker.open()"
                placeholder="Schedule date"
                i18n-placeholder="@@scheduleDate"
                [min]="minScheduleDate"
            />
            <mat-datepicker-toggle matSuffix [for]="$any(scheduledSendDatePicker)"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker closeOnDateSelect color="primary" #scheduledSendDatePicker>
                <ng-template>
                    <span i18n>Done</span>
                </ng-template>
            </ngx-mat-datetime-picker>
            <mat-error i18n="@@scheduleDateRequired">A schedule date is required!</mat-error>
        </mat-form-field>
    </div>
    <div class="internal-email-options" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
        <mat-checkbox [checked]="true" i18n="@@sendExternalEmail">Send e-mail externally</mat-checkbox>
        <mat-checkbox i18n="@@sendInternalK3">Send massage internal K3</mat-checkbox>
    </div>
    <app-text-editor
        [subject]="welcomeForm.value.subject"
        (onSubject)="welcomeForm.controls['subject'].patchValue($event)"
        formControlName="body"
        fieldName="userWelcomeMessage"
        title="Content"
        i18n-title
        fxFlex="1 0 100%"
    >
        <mat-error i18n="@@messageBodyError">Message body is required!</mat-error>
    </app-text-editor>

    <div
        *ngIf="!hideActions"
        fxFlex="1 0 100%"
        fxLayout="row wrap"
        fxLayoutAlign="end center"
        fxLayoutGap=".5em"
        class="mt-1"
    >
        <ng-container *ngIf="loading">
            <app-saving-button></app-saving-button>
        </ng-container>
        <button
            *ngIf="!loading && params?.importing"
            mat-raised-button
            type="button"
            color="accent"
            [routerLink]="['/admin/accounts/import/history/', params?.import]"
            i18n="@@sendEmailLater"
        >
            Send e-mail later
        </button>
        <button
            *ngIf="!loading && (params?.user_activation || params?.importing)"
            mat-raised-button
            type="button"
            color="accent"
            (click)="submitWelcomeMessage(true)"
            i18n="@@standardActivation"
        >
            Standard Activation
        </button>
        <button
            *ngIf="!loading"
            mat-raised-button
            color="primary"
            [disabled]="welcomeForm.invalid && welcomeForm.touched"
            (click)="submitWelcomeMessage()"
            i18n="@@sendEmail"
        >
            Send e-mail
        </button>
    </div>
</form>
